module.exports = __webpack_public_path__ + "images/trello-gold-logo-gold@2x.4aed30c34bf90d579f73.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/trello-gold-logo-gold@2x.png
// module id = ZzLm
// module chunks = 0